import { RecommendedTag } from 'components/RecommendedTag/RecommendedTag';
import styles from './radioContent.module.scss';

export const RadioContent = ({ Icon, title, description, isDisabled, isRecommended }) => {
    return (
        <div className={styles['radio-container']}>
            <div className={styles['icon-container']}>
                <Icon className={isDisabled ? styles['disabled'] : styles['enabled']} />
            </div>
            <div className={styles['upper-container']}>
                <div className={styles['title-container']}>
                    <div className={styles['title']}>{title}</div>
                    {isRecommended && <RecommendedTag />}
                </div>
                <div className={`${styles['description']} ${isRecommended ? styles['recommended'] : ''}`}>
                    {description}
                </div>
            </div>
        </div>
    );
};
